import Vue from 'vue'
// const apiRoot = process.env.API_ROOT;    //接口前缀
/**
 * 金额格式化
 * 例子：1234567890.01  =>  1,234,567,890.01
 * **/
// Vue.filter('moneyFormat', (value,dw) => {
//   //dw 货币单位预留字段
//   if (!dw) dw = '';
//   if (value === null || value === undefined || value === '') value = 0;
//   value = value.toString();
//   if (!value.split(".")[1]) {
//     return dw + " " + value.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,') + '.00';
//   } else if (value.split(".")[1].length == 1) {
//     return dw + " " + value.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,') + '0';
//   } else if (value.split(".")[1].length == 2) {
//     return dw + " " + value.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,');
//   }
// });


/**
 * 日期格式化
 * eg:{{data | timeFormat('yyyy-MM-dd hh:mm:ss')}}
 *  **/
Vue.filter('timeFormat', (value, f) => {
  if(!value) return '';
  var elem = new Date(value);
  var o ={
    "M+" : elem.getMonth()+1, //月
    "d+" : elem.getDate(),    //d日
    "h+" : elem.getHours(),   //时
    "m+" : elem.getMinutes(), //分
    "s+" : elem.getSeconds(), //秒
    "q+" : Math.floor((elem.getMonth()+3)/3),
    "S" : elem.getMilliseconds()
  }
  if(/(y+)/.test(f)) f=f.replace(RegExp.$1,(elem.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(f))f = f.replace(RegExp.$1,RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));return f
});

/**
 *  汇率不足6位小数，补零
 * **/
Vue.filter('rateFormat', (x) => {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return '';
  }
  if (x == 0) {
    return 0
  }
  var f = Math.round(x * 1000000) / 1000000;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 6) {
    s += '0';
  }
  return s;
});
/**
 *  金额不足2位小数，补零
 * **/
Vue.filter('moneyFormat', (x, code, dw) => {
  if (!dw) dw = '';   //dw 货币单位预留字段
  var f = parseFloat(x);
  if (isNaN(f)) {
    return '';
  }
  if(x == 0) {
    return 0
  }
  if (code && code === 'JPY') {
    return f.toFixed(0).toString().replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,');
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  // var rs = s.indexOf('.');
  if (!s.split(".")[1]) {
    return dw + " " + s.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,') + '.00';
  } else if (s.split(".")[1].length == 1) {
    return dw + " " + s.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,') + '0';
  } else if (s.split(".")[1].length == 2) {
    return dw + " " + s.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,');
  }
  // if (rs < 0) {
  //   rs = s.length;
  //   s += '.';
  // }
  // while (s.length <= rs + 2) {
  //   s += '0';
  // }
  return s;
});

/**
 *  英国业务类型
 * **/
// Vue.filter('companyType', (value) => {
//     let data = value ? value.type : "";
//     if(data == 'Wholesale')
//       return  '批发';
//     else
//       return  '零售';
// });

export default {}



// WEBPACK FOOTER //
// ./src/public/filters.js